export default "__VITE_ASSET__BJSVcwgB__"